import api from '../api'
import axios from '../axios'

class OrderService {
  /**
   * 订单详情
   */
  static getDetail ({ order_no }) {
    return axios.get(api.reserve.order.detail, { params: { order_no } })
  }

  // 我的订单列表
  static getList ({ status, page }) {
    return axios.get(api.reserve.order.list, { params: { status, page } })
  }

  // 补全材料
  static updateAdditionalInfo ({ form }) {
    return axios.post(api.reserve.order.addbuyerinfo, form)
  }

  // 取消订单
  static doCancle ({ order_no }) {
    return axios.post(api.reserve.order.cancel, { order_no })
  }

  // 删除订单
  static doDel ({ order_no }) {
    return axios.post(api.reserve.order.del, { order_no })
  }

  // 获取支付签名
  static getPaySign (data) {
    return axios.post(api.reserve.order.pay, data)
  }
}

export default OrderService
